module.exports = __webpack_public_path__ + "static/obvious_2-18d0767cfe1d5d9e2c0e09bfb9140ad4.jpg";